import { Box, Button, Grid, InputLabel, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import CustomInput from "../../../../../components/CustomInput";
import style from "./style";
import { useForm } from "../../../../../hooks/useForm";
import { createBankValidation } from "../../../../../helper/Validation";
import PhoneInput from "react-phone-input-2";

function EditBankPage({ handleEdit, item }) {
  const [mobile, setMobile] = useState(item?.phone?.toString());
  const [cCode, setCCode] = useState(item?.cCode?.toString());
  const mobileNumberRef = useRef(null);

  const handleBankData = (data) => {
    handleEdit(data,mobile,cCode);
  };
  const editBank = {
    bankName: { value: item?.name || "", error: "", focus: null },
    branch: { value: item?.branch || "", error: "", focus: null },
    accountHolder: { value: item?.accountHolder || "", error: "", focus: null },
    accountNumber: { value: item?.accountNumber || "", error: "", focus: null },
    phone: { value: item?.phone || "", error: "", focus: null },
    initialBalance: {
      value: item?.initialBalance || "",
      error: "",
      focus: null,
    },
    internetBanking: { value: item?.bankingURL || "", error: "", focus: null },
    swiftCode: { value: item?.swiftCode || "", error: "", focus: null },

  };
  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    editBank,
    createBankValidation,
    handleBankData
  );
  const handleOnChanges = (value, country) => {
    setMobile(value);
    setCCode(country?.dialCode);
  };
  const {
    bankName,
    branch,
    accountHolder,
    accountNumber,
    initialBalance,
    internetBanking,
    swiftCode
  } = state;
  return (
    <Box px="15px" pt="20px">
      <form onSubmit={(e) => handleSubmit(e)}>
        <Typography sx={style.heading}>Edit Bank Account</Typography>
        <Box>
          <Grid container>
            <Grid item xs={12} sx={style.card}>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Bank Name<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="bankName"
                    fullWidth
                    defaultValue={item?.name}
                    placeholder="Enter Bank Name"
                    value={bankName.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={bankName.error}
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Branch<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="branch"
                    fullWidth
                    defaultValue={item?.branch}
                    value={branch.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={branch.error}
                    placeholder="Enter Branch"
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Account Holder Name<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="accountHolder"
                    fullWidth
                    defaultValue={item?.accountHolder}
                    value={accountHolder.value}
                    onChange={handleChange}
                    placeholder="Enter Account Holder Name"
                    onFocus={handleFocus}
                    error={accountHolder.error}
                  />
                </Box>
              </Box>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Account Number<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="accountNumber"
                    fullWidth
                    defaultValue={item?.accountNumber}
                    value={accountNumber.value}
                    onChange={handleChange}
                    placeholder="Enter Account Number"
                    onFocus={handleFocus}
                    error={accountNumber.error}
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Swift Code<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="swiftCode"
                    fullWidth
                    defaultValue={item?.swiftCode}
                    value={swiftCode?.value}
                    onChange={handleChange}
                    placeholder="Enter Swift Code"
                    onFocus={handleFocus}
                    error={swiftCode.error}
                  />
                </Box>
                
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Initial Balance<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="initialBalance"
                    fullWidth
                    defaultValue={item?.initialBalance}
                    value={initialBalance.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    placeholder="Enter Initial Balance"
                    error={initialBalance.error}
                  />
                </Box>
              </Box>
              <Box sx={style.inputSections}>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>Mobile</InputLabel>
                  <PhoneInput
                    country={"za"}
                    enableSearch={true}
                    value={mobile}
                    defaultValue={cCode}
                    name="mobile"
                    onChange={(value, country) =>
                      handleOnChanges(value, country)
                    }
                    onFocus={handleFocus}
                    ref={mobileNumberRef}
                    error={mobile?.error}
                    sx={style.mobile}
                    inputProps={{
                      style: {
                        height: "1em",
                        borderRadius: "10px",
                        width: "100%",
                        marginTop: "7px",
                      },
                    }}
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>Internet Banking URL</InputLabel>
                  <CustomInput
                    name="internetBanking"
                    fullWidth
                    defaultValue={item?.bankingURL}
                    placeholder="Internet Banking URL"
                    value={internetBanking.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={internetBanking.error}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box px={2}>
            <Button
              variant="contained"
              sx={style.jobButtons}
              disabled={!bankName?.value || bankName?.error || !branch?.value || branch?.error || !accountHolder?.value || accountHolder?.error || !accountNumber?.value || accountNumber?.error || !swiftCode?.value || swiftCode?.error || initialBalance?.error}
              type="submit"
            >
              {"Update Changes"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
}

export default EditBankPage;